// Third party packages
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
// Custom packages
import { TranslateService } from "@ngx-translate/core";
import { ApiService } from "src/app/shared/services/api.service";
import { HelperService } from "src/app/shared/services/helper.service";
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
import * as i3 from "@ngx-translate/core";
var StatementsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function StatementsService(apiService, helperService, translateService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.translateService = translateService;
    }
    /**
     * Create a new statements
     *
     * @since 1.0.0
     *
     * @param statement Statement data
     * @returns Observable<any>
     */
    StatementsService.prototype.create = function (statement) {
        return this.apiService.apiCall("POST", "statements", statement);
    };
    /**
     * Get statements list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    StatementsService.prototype.getList = function (propertyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "statements/" + propertyId, params);
    };
    /**
     * Get an exportation file of statements
     *
     * @since 1.0.0
     */
    StatementsService.prototype.getExport = function (propertyId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "statements/export/" + propertyId, {}, { responseType: "blob" })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get given statementId data from back-end
     *
     * @since 1.0.0
     *
     * @param propertyId ID of the property to get
     * @param statementId ID of the statement to get
     */
    StatementsService.prototype.get = function (propertyId, statementId) {
        var _this = this;
        return this.apiService.apiCall("GET", "statements/" + propertyId + "/" + statementId).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update statement with given statementId with given statement data
     *
     * @since 1.0.0
     *
     * @param statementId ID of statement to update
     * @param data New balance's data
     */
    StatementsService.prototype.updateFields = function (propertyId, statementId, data) {
        return this.apiService.apiCall("PATCH", "statements/" + propertyId + "/" + statementId, data);
    };
    /**
     * Delete permanently a statement
     *
     * @since 1.0.0
     *
     * @param statementId ID of the statement
     */
    StatementsService.prototype.delete = function (propertyId, statementId) {
        return this.apiService.apiCall("DELETE", "statements/" + propertyId + "/" + statementId);
    };
    StatementsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StatementsService_Factory() { return new StatementsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.TranslateService)); }, token: StatementsService, providedIn: "root" });
    return StatementsService;
}());
export { StatementsService };
